<template>
<div class="item">
    <div class="shopping-rating" v-if="!sended">
        <h3>Online satın alma deneyiminizden ne seviyede memnun kaldınız?</h3>
        <div class="rate">
            <a v-for="index in 5" :key="'star' + index" @click="selectedIndex = index" @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null"><img :src="getStarSrc(index)"></a>
        </div>
        <div class="rate-form" v-show="selectedIndex != null">
            <div class="item">
                <textarea class="textarea" placeholder="Görüşlerinizi yazınız" maxlength="150" v-model="description"></textarea>
            </div>
            <div class="item">
                <button class="button inline-btn white-brd-btn" @click="send">GÖNDER</button>
            </div>
        </div>
    </div>
    <div class="shopping-rating" v-if="sended">
        <iframe frameBorder="0" width="0" height="0" :src="pisanoLink"></iframe>
        <h3>Teşekkürler</h3>
    </div>
</div>
</template>

<script>

export default {
    data() {
        return {
            selectedIndex: null,
            hoveredIndex: null,

            description: null,
            sended: false
        }
    },
    props: {
        policeNo: {

        },
        urunAdi: {

        }
    },
    computed: {
        pisanoLink() {
            if(this.selectedIndex == null) {
                return null
            }

            let sentiment = null
            switch(this.selectedIndex) {
                case 0:
                    sentiment = 'e8c3e34a-5b7b-48c2-9825-7443f439621e'
                    break
                case 1:
                    sentiment = '5b135b70-ddf7-40dc-a961-813a2a25ab2d'
                    break
                case 2:
                    sentiment = 'f1f2555a-0f80-4fc7-8ec2-53401241d8a8'
                    break
                case 3:
                    sentiment = 'faa2cdea-575f-484e-8769-e96ace0e3978'
                    break
                case 4:
                    sentiment = 'cda2597b-92b1-4ef1-b828-1936f6918aa4'
                    break
            }

            let responses = window.btoa(JSON.stringify([
                {
                    question: 'POLICE_NO',
                    answer: this.$props.policeNo
                },
                {
                    question: 'KOTASYON_URUN',
                    answer: this.$props.urunAdi
                },
                {
                    question: 'sentiment',
                    answer: sentiment
                },
                {
                    question: 'aciklama',
                    answer: this.description
                }
            ]))
            
            return 'https://pisano.com.tr/web_feedback?node_id=9a8beeef-022c-4fee-afcd-90e6c3fc4515&responses=' + responses
        }
    },
    methods: {
        getStarSrc(index) {
            let isSelected = this.selectedIndex && this.selectedIndex >= index
            let isHovered = this.hoveredIndex && this.hoveredIndex >= index

            if(isSelected) {
                return require('@/assets/images/icon/star1.png')
            }

            if(isHovered) {
                return require('@/assets/images/icon/star2.png')
            }

            return require('@/assets/images/icon/star4.png')
        },
        send() {
            if(this.selectedIndex != null) {
                this.sended = true
            }
        }
    }
};
</script>
